import {
  LucideActivity,
  LucideArrowLeft,
  LucideBanknote,
  LucideBarChart3,
  LucideBus,
  LucideCalendar,
  LucideCircleCheck,
  LucideCircleX,
  LucideCreditCard,
  LucideEye,
  LucideFileText,
  LucideGlobe,
  LucideLayoutDashboard,
  LucideLogOut,
  LucideMapPin,
  LucideMenu,
  LucideMoreHorizontal,
  LucideNewspaper,
  LucidePencil,
  LucidePlus,
  LucideRadio,
  LucideSearch,
  LucideSettings,
  LucideTicket,
  LucideTrendingUp,
  LucideTrophy,
  LucideTruck,
  LucideUpload,
  LucideUsers,
  LucideWallet,
  LucideWrench,
  LucideX,
  provideLucideIcons,
} from '@lucide/angular';

export const lucideIconsProvider = provideLucideIcons(
  LucideArrowLeft,
  LucideLayoutDashboard,
  LucideBus,
  LucideUsers,
  LucideRadio,
  LucideTruck,
  LucideSettings,
  LucideBanknote,
  LucideFileText,
  LucideNewspaper,
  LucideBarChart3,
  LucideTicket,
  LucideMapPin,
  LucideLogOut,
  LucideMenu,
  LucideX,
  LucideSearch,
  LucidePlus,
  LucideGlobe,
  LucideCircleCheck,
  LucideCircleX,
  LucideCreditCard,
  LucideTrendingUp,
  LucideMoreHorizontal,
  LucideUpload,
  LucideEye,
  LucidePencil,
  LucideTrophy,
  LucideWallet,
  LucideWrench,
  LucideActivity,
  LucideCalendar,
);
